import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/sections/HeroSection';
import { WhatIsMeeloSection } from '../components/sections/WhatIsMeeloSection';
import { DashboardSection } from '../components/sections/DashboardSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { FindSolutionCTASection } from '../components/sections/FindSolutionCTASection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { SocialProofSection } from '../components/sections/SocialProofSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { Footer } from '../components/Footer';
// Thin gradient divider between sections
function SectionDivider({
  variant = 'line'
}: {
  variant?: 'line' | 'glow';
}) {
  if (variant === 'glow') {
    return <div aria-hidden="true" style={{
      height: 1,
      background: 'transparent',
      position: 'relative',
      overflow: 'visible'
    }} data-id="element-366">
        <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: 40,
        background: 'radial-gradient(ellipse at center, rgba(124,77,255,0.10) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} data-id="element-367" />
      </div>;
  }
  return <div aria-hidden="true" style={{
    height: 1,
    margin: '0 auto',
    width: '80%',
    background: 'linear-gradient(90deg, transparent 0%, rgba(124,77,255,0.15) 30%, rgba(124,77,255,0.25) 50%, rgba(124,77,255,0.15) 70%, transparent 100%)'
  }} data-id="element-368" />;
}
export function LandingPage() {
  // Section scroll-reveal: observe all <section> elements
  useEffect(() => {
    // Handle scroll-to from MissionPage
    const scrollTarget = sessionStorage.getItem('scrollTo');
    if (scrollTarget) {
      sessionStorage.removeItem('scrollTo');
      setTimeout(() => {
        document.getElementById(scrollTarget)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 350);
    }
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('main > .section-wrap');
    if (prefersReduced) {
      sections.forEach(el => el.classList.add('section-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.06
    });
    sections.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans text-gray-900" data-id="element-369">
      <Navbar data-id="element-370" />
      <main data-id="element-371">
        {/* Hero — no reveal wrapper, always visible */}
        <HeroSection data-id="element-372" />

        <div className="section-wrap" data-id="element-373">
          <DashboardSection data-id="element-374" />
        </div>

        <div className="section-wrap" data-id="element-375">
          <SolutionSection data-id="element-376" />
        </div>

        <SectionDivider variant="line" data-id="element-377" />
        <div className="section-wrap" data-id="element-378">
          <FindSolutionCTASection data-id="element-379" />
        </div>

        <SectionDivider variant="line" data-id="element-380" />
        <div className="section-wrap" data-id="element-381">
          <ResultsSection data-id="element-382" />
        </div>

        <SectionDivider variant="glow" data-id="element-383" />
        <div className="section-wrap" data-id="element-384">
          <SocialProofSection data-id="element-385" />
        </div>

        <SectionDivider variant="line" data-id="element-386" />
        <div className="section-wrap" data-id="element-387">
          <FinalCTASection data-id="element-388" />
        </div>
      </main>
      <Footer data-id="element-389" />
    </div>;
}